export default "__VITE_ASSET__e3453657__"